import styled from '@emotion/styled';
import { Modal, Spin } from 'antd';
import React from 'react';
import { useAppSelector } from 'src/reducers/model';
import tw from 'twin.macro';

const LoadingModalStyled = styled(Modal)`
  .ant-modal-content {
    ${tw`bg-transparent shadow-none`}
  }
`;

const LoadingModal = () => {
  const countLoading = useAppSelector(state => state.app.countLoading);
  return (
    <>
      {countLoading > 0 && (
        <LoadingModalStyled
          destroyOnClose
          zIndex={1500}
          closable={false}
          footer={null}
          open={countLoading > 0}
          centered
        >
          <section className="flex justify-center">
            <Spin size="large" />
          </section>
        </LoadingModalStyled>
      )}
    </>
  );
};

export default LoadingModal;
